import { Link } from "react-router-dom";
import { categories, games } from "@/mocks/games";

export default function CategoriesSection() {
  return (
    <section id="categories" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">Categories</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            按类型找到你的菜
          </h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600">
          八类主流题材，每类都标注了适合人群与口碑方向，帮你在最短时间内缩小范围。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {categories.map((c) => {
          const count = games.filter((g) => g.category === c.id).length;
          return (
            <Link
              key={c.id}
              to={`/ranking?cat=${c.id}`}
              className="group flex flex-col rounded-xl border border-background-200/70 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-300 hover:bg-background-100"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${c.icon} text-xl`}></i>
              </div>
              <div className="mt-4 flex items-center justify-between">
                <h3 className="font-display text-base font-bold text-foreground-950">{c.name}</h3>
                <span className="rounded-full bg-background-200 px-2 py-0.5 text-xs text-foreground-500">{count} 部</span>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}